/**
 * Created by mzietek on 2017-03-08.
 */

(function (angular) {
    'use strict';

    angular
        .module("repairforms.factory.module")
        .factory("DatepickerManagerFactory", DatepickerManagerFactory);

    DatepickerManagerFactory.$inject = ['DatepickerInitPropertiesFactory', 'DateService'];

    function DatepickerManagerFactory(DatepickerInitPropertiesFactory, DateService) {

        return {
            getDatepickerManager : getDatepickerManager
        };

        function getDatepickerManager(datepickerEl) {

            var datepickerManager = {
                datepickerElement: datepickerEl,

                initDatepicker: function(dateChangeCallback) {
                    this.setTranslations();
                    this.setInitProperties();
                    if(dateChangeCallback) {
                        this.setOnChange(dateChangeCallback);
                    }
                },

                setTranslations: function() {
                    var translationProperties = DatepickerInitPropertiesFactory.getTranslationProperties();
                    if(translationProperties) {
                        var datepickerLang = DatepickerInitPropertiesFactory.getDatepickerLang();
                        var datepicker = this.datepickerElement.datepicker;
                        datepicker.dates[datepickerLang] = translationProperties;
                    }
                },
                setInitProperties: function() {
                    this.datepickerElement.datepicker(DatepickerInitPropertiesFactory.getInitProperties());
                },
                setOnChange: function(dateChangeCallback) {
                    this.datepickerElement.datepicker().on('changeDate', dateChangeCallback);
                },
                updateFirstValidPickUpDate: function() {
                    this.datepickerElement.datepicker('startDate', DateService.getFirstValidDate(DatepickerInitPropertiesFactory.pickUpHourLimit))
                }
            };

            return datepickerManager;
        };

    }

})(angular);